var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditNotes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "invoice_2_",
    "data-name": "invoice (2)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.083,
    height: 32.111,
    viewBox: "0 0 24.083 32.111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_82323",
    "data-name": "Group 82323",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3382",
    "data-name": "Path 3382",
    d: "M87.886,6.885,81.2.2a.667.667,0,0,0-.474-.2H66.676A2.679,2.679,0,0,0,64,2.676V29.435a2.679,2.679,0,0,0,2.676,2.676H85.407a2.679,2.679,0,0,0,2.676-2.676V7.359A.667.667,0,0,0,87.886,6.885ZM70.021,9.366a2,2,0,0,1-.669-3.891V5.352a.669.669,0,1,1,1.338,0h.669a.669.669,0,0,1,0,1.338H70.021a.669.669,0,1,0,0,1.338,2,2,0,0,1,.669,3.891v.123a.669.669,0,1,1-1.338,0h-.669a.669.669,0,1,1,0-1.338h1.338a.669.669,0,1,0,0-1.338ZM76.711,28.1H68.683a.669.669,0,0,1,0-1.338h8.028a.669.669,0,1,1,0,1.338Zm6.69-4.014H68.683a.669.669,0,0,1,0-1.338H83.4a.669.669,0,1,1,0,1.338Zm0-4.014H68.683a.669.669,0,0,1,0-1.338H83.4a.669.669,0,1,1,0,1.338Zm0-4.014H68.683a.669.669,0,0,1,0-1.338H83.4a.669.669,0,1,1,0,1.338Zm0-4.014H75.373a.669.669,0,0,1,0-1.338H83.4a.669.669,0,1,1,0,1.338ZM82.731,6.69a1.339,1.339,0,0,1-1.338-1.338V2.284L85.8,6.69Z",
    transform: "translate(-64)",
    fill: "#2b64fa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditNotes);
export default __webpack_public_path__ + "static/media/creditNotes.4dcf54aa7ded2177a30d876128c3671d.svg";
export { ForwardRef as ReactComponent };